export default __webpack_public_path__ + "static/media/calender.f306b918.svg";